import { useEffect, useRef, useState } from "react";
import { BasicPage } from "../theme/Component/BasicPage"
import { CardTaps } from '../theme/Component/CardTaps';
import { BasicTable, MASK_DATE, MASK_DATE_YYYYMMDD_HHMM, MASK_NUMBER } from "../theme/Component/BasicTable";
import { DropDown } from "../theme/Component/DropDown";
import { Modal } from "../theme/Component/Modal";
import useDataBean from "../../core/services/dataBean/useDataBean";
import { _RequestApprovalBpm, _single } from "../../core/services/dataBean/EntityCatalog";
import { toast } from "react-toastify";
import { env } from "../../env";
import { AccountEditor } from "../editor/AccountEditor";
import { BasicMultiSelectTable } from "../theme/Component/BasicMultiSelecTable";
import { ListMenu } from "../theme/Component/ListMenu";
import { ValidationOtp } from "../theme/Component/ValidationOTP/ValidationOtp";
import { HandlerInfoProcess } from "../bpm/config/InfoTramiteComponents/HandlerInfoProcess";
import { SignResume } from "./SignResume";
import usePaginator from "../theme/Component/usePaginator";
import useModal, { MODAL_LG, MODAL_md } from "../theme/Component/hooks/useModal";
import { ExpedienteTRD } from "../expediente/ExpedienteTRD";
import { BasicButton } from "../theme/Component/BasicButton";
import { PrintJson } from "../theme/Component/PrintJson";

export const MisApprovals = () => {


    const testMode = env.PRINT_LOG ?? false;

    const { instance } = useDataBean(_RequestApprovalBpm);

    const taps = [
        { id: 0, name: 'Pendientes' },
        { id: 1, name: 'Aprobados' },
        { id: 2, name: 'Rechazados' }
    ]

    const [indexTap, setIndexTap] = useState(0);
    const [state, setState] = useState(2);
    const [idAccount, setIDAccount] = useState<number>(_single.getAccountID());
    const [obs, setObs] = useState('');
    const [isMultiApproval, setIsMultiApproval] = useState(false);
    const [lista, setLista] = useState<any>([]);
    const [listaSign, setListaSign] = useState<any>([]);
    const [listaResult, setListaResult] = useState<any>([]);
    const [bean, setBean] = useState<any>({});
    const [turn, setTurn] = useState<any>({});
    const [action, setAction] = useState<any>({});

    const modal = useModal("Aprobar", MODAL_LG);
    const modalMulti = useModal("Seleccione una o varias Aprobaciones", MODAL_LG)
    const modalHistory = useModal("Información del Tramite", MODAL_LG)

    const [filter, setFilter] = useState<any>({});
    const modalRequisito = useModal("Expediente", MODAL_LG);
    const [states] = useState<any>([
        { id: 2, name: 'Aprobado' },
        { id: 3, name: 'Rechazado' },
    ]);
    const [miTurno, setMiturno] = useState<boolean>(false);

    useEffect(() => {

        setBean({});
        getLista();

    }, [indexTap])

    useEffect(() => {
        setBean({});
        getLista();
    }, [idAccount])

    useEffect(() => {
        setListaResult([]);
        if (action.id === 3) {
            modalMulti.open();
            setIsMultiApproval(true);
        }
    }, [action])



    const paginator = usePaginator();

    useEffect(() => {
        getLista()
    }, [paginator.page])

    const getLista = () => {
        let st = 1;
        if (indexTap === 0)
            st = 1;
        if (indexTap === 1)
            st = 2;
        if (indexTap === 2)
            st = 3;

        let filtro: any = {
            IDAccountSign: idAccount, SignSate: st
        }
        if (filter.Mnemonic?.length > 1) {
            filtro.Mnemonic = filter.Mnemonic
        }

        instance.getRequestApprovalBpmCatalogRender(paginator.page, 15, filtro).then(
            (resp: any) => {
                let temp = resp.List;
                temp.forEach(element => {
                    if (element.DataBeanProperties.IDApprovaldocument) {
                        element.DataBeanProperties.Name = element.DataBeanProperties.Title + " " + element.DataBeanProperties.Mnemonic;
                        element.DataBeanProperties.AlphaCode = element.DataBeanProperties.AlphaCode ?? element.DataBeanProperties.Consecutive;
                    }
                });
                setLista(temp);

                paginator.setPages(resp.NumberOfPages);

            }).catch(err => toast.error(err));
    }

    const singRequestProcessBpm = () => {
        instance.singRequestProcessBpm(bean.IDRequestApprovalBpm, state, obs, _single.getAccountID()).then(
            (resp: any) => {
                toast.success("Se ha realizado la acción correctamente");
                modal.close();
                getLista();
            }).catch(
                err => {
                    toast.error(err);
                }
            );
    }

    const multipleRequestProceesBpm = () => {
        const tempList = listaResult.map(item => item.DataBeanProperties.IDRequestApprovalBpm);
        console.log("Lista de IDProcedureImp:", tempList);
        instance.singListRequestProcessBpm(tempList, state, obs, _single.getAccountID()).then(
            (resp) => {
                toast.success("Se ha realizado la acción correctamente");
                modal.close();
                getLista();
            }
        ).catch(
            err => {
                toast.error(err);
            }
        )
    }


    const head = [
        { title: '#', property: 'IDApprovaldocument', visible: true, mask: MASK_NUMBER },
        { title: 'No. Solicitud', property: 'AlphaCode', visible: true, mask: MASK_NUMBER },
        { title: 'Solicitud', property: 'Name', visible: true },
        { title: 'Fecha', property: 'FromDate', visible: true, mask: MASK_DATE_YYYYMMDD_HHMM },
        { title: 'Estado', property: 'StateName', visible: true },
    ]

    const headMulti = [
        { title: '#', property: 'IDRequestApprovalBpm', visible: true, mask: MASK_NUMBER },
        { title: 'No. Solicitud', property: 'AlphaCode', visible: true },
        { title: 'Solicitado', property: 'Since', visible: true, mask: MASK_DATE_YYYYMMDD_HHMM },
        { title: 'Solicitud', property: 'Name', visible: true },
        { title: 'Estado', property: 'StateName', visible: true },
    ]

    const actionsDropDown = [
        { id: 3, name: 'Aprobar Varios', permiso: null, activo: true },
    ];

    const buttons = () => {
        return (
            <div className="row">
                <div className="col-md-12">
                    {indexTap === 0 &&
                        <DropDown lista={actionsDropDown} eventClick={setAction}></DropDown>
                    }
                </div>
            </div>
        )
    }

    const listaBotones = () => {
        const botones = [
            {
                titulo: 'Gestionar', icono: 'ri-edit-2-line', visible: bean.SignSate === 1, evento: () => {
                    esTurno();
                }
            },
            { titulo: 'Historial del Procedimiento', icono: 'ri-file-chart-line', visible: true, evento: () => { modalHistory.open() } },
            { titulo: 'Expediente Adjuntos', icono: ' ri-folder-2-line', visible: true, evento: () => { modalRequisito.open() } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const otpValidator = useRef<any>(null);
    const saveInfo = () => {
        if (otpValidator.current) {
            otpValidator.current.openOTPModal("Validacion de Identidad");
            // modal.close()
        }
    }

    const esTurno = () => {

        instance.getRequestApprovalSingRender(bean.IDApprovaldocument).then((resp: any) => {
            setListaSign(resp);
            validarTurno(resp);

        }).catch(err => toast.error(err))
    }
    const validarTurno = (lis: any) => {
        // 1. Filtrar por State = 1
        const filtrados = lis.filter(item => item.DataBeanProperties.State === 1);

        // 2. Ordenar por ItemOrder ascendente
        const ordenados = filtrados.sort(
            (a, b) => a.DataBeanProperties.ItemOrder - b.DataBeanProperties.ItemOrder
        );
        let t = false;
        let tt: any = {};

        // 3. Tomar el primero y validar si su IDAccount coincide con el mío
        if (ordenados.length > 0) {
            if (ordenados[0].DataBeanProperties.IDAccount === _single.getAccountID()) {
                t = true;

            }
            else {
                t = false;
                tt = ordenados[0].DataBeanProperties;
                setTurn(tt);
            }

        }
        setMiturno(t);

        if (t) {
            modal.open();
            setIsMultiApproval(false);
        } else {
            toast.warning(`Documento con firma pendiente de : ${tt.EntityName}`);
        }
    }

    return (
        <BasicPage titulo="Mis Aprobaciones">
            <CardTaps index={indexTap} taps={taps} updateIndex={setIndexTap}>
                <div className="row">
                    <div className="col-md-4">
                        {(testMode && _single.canEdit()) ?
                            <AccountEditor idAccount={idAccount} label="Tercero" onChange={(e: any) => { setIDAccount(e.IDAccount) }} />
                            :
                            <div>
                                <label>Tercero</label>
                                <input type="text" className="form-control" name="user" id="user" readOnly value={_single.getAccount().EntityName} />
                            </div>
                        }
                    </div>
                    <div className="col-md-3">
                        <label>Filtro</label>
                        <input type="text" className="form-control" value={filter.Mnemonic} onChange={(e) => { setFilter({ ...filter, "Mnemonic": e.target.value }) }} />
                    </div>
                    <div className="col-md-3">
                        <BasicButton icon="" useMargin eventClick={getLista}>Buscar</BasicButton>
                    </div>
                    <div className="col-md-12">
                        <BasicTable listButtons={listaBotones()} headButtons={buttons()} head={head} body={lista} rowSet={setBean} pageTop={paginator.page} next={paginator.next} back={paginator.back} records={paginator} />
                    </div>
                </div>
            </CardTaps>

            <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={saveInfo} onSubmitLabel="Enviar">
                <div className="row">
                    {miTurno ?
                        <>
                            <div className="col-md-6">
                                <label>Estado</label>
                                <select name="states" className="form-select" value={state} onChange={(e) => { setState(parseInt(e.target.value)) }}>
                                    {states.map((item: any, index: number) => {
                                        return <option key={index} value={item.id}>{item.name}</option>
                                    })}
                                </select>
                            </div>
                            <div className="col-md-12">
                                <label>Observaciones</label>
                                <textarea className="form-control" value={obs} onChange={(e) => { setObs(e.target.value) }}></textarea>
                            </div>

                            <div className="col-md-12">
                                <ValidationOtp onValidate={isMultiApproval ? multipleRequestProceesBpm : singRequestProcessBpm} ref={otpValidator} />
                            </div>
                        </>
                        :
                        <>
                            <p>Pendiente por firma de : </p>
                            {/* <PrintJson json={listaSign} /> */}
                        </>
                    }
                </div>
            </Modal>

            <Modal modal={modalMulti.modal} updateModal={modal.setModal} eventModal={() => {
                setIsMultiApproval(true);
                modal.open();
                modalMulti.close();
            }}>
                <BasicMultiSelectTable keyId="IDRequestApprovalBpm" body={lista} bodyResult={listaResult} head={headMulti} pageTop={paginator.page} next={paginator.next} back={paginator.back} records={paginator}
                    updateValues={({ bodyResult }) => {
                        setListaResult(bodyResult);
                        // console.log(bodyResult);
                    }}
                />
            </Modal>
            <Modal modal={modalRequisito.modal} updateModal={modalRequisito.setModal}>
                <ExpedienteTRD typeExpediente="GENERAL" dataExpediente={bean} />
            </Modal>

            <div className="col-md-12">
                <Modal modal={modalHistory.modal} updateModal={modalHistory.setModal} >
                    {bean.IDApprovaldocument ?
                        <SignResume data={bean} />
                        :
                        <HandlerInfoProcess _ProcedureIMPID={bean.IDProcedureImp} />
                    }
                </Modal>
            </div>
        </BasicPage>
    )
}